import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const Wrapper = styled(Box)({
  flex: 1,
  display: 'flex',
  marginTop: 18,
  width: 300,
  height: '100%',
  flexDirection: 'column',
})

export const BtnSectionWrapper = styled('div')(({ theme }) => ({
  width: '21%',
  position: 'fixed',
  bottom: 0,
  display: 'flex',
  flexDirection: 'row',
  gap: '10px',
  backgroundColor: theme.palette.common.white,
  padding: '10px 0px',
}))

export const BtnWrap = styled('div')({
  marginLeft: '45%',
})
